import { render } from "./ContactsPeopleDetails.vue?vue&type=template&id=62312daa&scoped=true"
import script from "./ContactsPeopleDetails.vue?vue&type=script&lang=js"
export * from "./ContactsPeopleDetails.vue?vue&type=script&lang=js"

import "./ContactsPeopleDetails.vue?vue&type=style&index=0&id=62312daa&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62312daa"]])

export default __exports__